import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Bubble, LoaderButton } from "ctia-ui";

const BatteryLabDecisionBLC = ({ id, isAccepted }) => {
  const resultTitle = isAccepted ? "accepted" : "rejected";
  const renderReportsLink = () => {
    if (!isAccepted) return null;
    return (
      <Link to={`/blc/lab/results/${id}`}>
        <LoaderButton bsStyle="info" text="Upload Reports &rarr;" />
      </Link>
    );
  };

  return (
    <div>
      <Bubble>Request has been successfully {resultTitle}.</Bubble>
      <Link to="/blc/lab/requests" className="button-right-offset">
        <LoaderButton text="Done" />
      </Link>
      {renderReportsLink()}
    </div>
  );
};

BatteryLabDecisionBLC.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isAccepted: PropTypes.bool
};

BatteryLabDecisionBLC.defaultProps = {
  isAccepted: false,
  id: 1
};

export default BatteryLabDecisionBLC;
